export default "__VITE_ASSET__CH2jRvOX__"